<template>
    <v-layout row>      
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <div v-if="isMobile" class="apps-container">
                        <v-menu left offset-y >
                            <template v-slot:activator="{ on }">
                                <v-list-tile-avatar>
                                    <v-btn flat dark icon small v-on="on">
                                        <v-icon>apps</v-icon>
                                    </v-btn>
                                </v-list-tile-avatar>
                            </template>
                            <v-list>
                                <v-list-tile>
                                    <v-btn icon to="/myattendance/calendar" title="View My Calendar">
                                        <v-icon>far fa-calendar-alt</v-icon> 
                                    </v-btn> 
                                </v-list-tile>
                                <v-list-tile >
                                    <v-btn icon title="Add Personal Time Off" @click="showPTO" :disabled="disableConditions">
                                        <v-icon>work_off</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-btn icon title="Add Overtime" @click="showOvertime" :disabled="disableConditions">
                                        <v-icon>far fa-calendar-plus</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <help-link appId="attendance" pageId="myattendance" color="black"></help-link>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <div v-else class="apps-container">
                        <v-btn dark icon to="/myattendance/calendar" title="View My Calendar">
                            <v-icon>far fa-calendar-alt</v-icon>
                        </v-btn>
                        <v-btn dark icon title="Add Personal Time Off" @click="showPTO" :disabled="disableConditions">
                            <v-icon>work_off</v-icon>
                        </v-btn>
                        <v-btn dark icon title="Add Overtime" @click="showOvertime" :disabled="disableConditions">
                            <v-icon>far fa-calendar-plus</v-icon>
                        </v-btn>
                        <help-link appId="attendance" pageId="myattendance" color="white"></help-link>
                    </div>
                    
                    <v-spacer></v-spacer>
                    <v-btn dark icon small title="View Previous Day" @click="viewPrevious" style="margin-right:-3px;" :disabled="loading">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <v-toolbar-title class="subheading transparent white--text" :title="$moment(serverDate).format('MMM DD, YYYY h:mm a')">Today&nbsp;&nbsp;</v-toolbar-title>
                    <v-btn dark icon small title="View Next Day" @click="viewNext" :disabled="loading">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <div :class="isMobile?'mt-10':''">
                <v-alert v-if="error" :value="true" color="error" icon="error" outline class="content-alert">
                    {{errorMessage}}    
                </v-alert>
                <v-alert v-if="!loading&&!hasAddRights" :value="true" color="warning" icon="warning" outline class="content-alert">
                    You need ADD rights on the My Attendance Page to clock in/out. Please check with your admin.
                </v-alert>
                <v-alert v-if="isHoliday" :value="true" color="info" icon="info" outline class="content-alert">
                    {{holidayDescription}}    
                </v-alert>
                <v-alert v-if="!loading&&!withAssignedWorkShift" :value="true" color="warning" icon="warning" outline class="content-alert">
                    You have no assigned work shift for this date.
                </v-alert>
            </div>
            <div v-if="!loading && !hasCutoffData">
                <v-alert :value="true" color="warning" icon="warning" outline class="content-alert">
                    Cutoff period has not been created for this date.
                </v-alert>
            </div>
            <div v-else>
                <v-alert v-if="cutOffStatus==commonfn.getStatusCode('Frozen')" :value="true" color="warning" icon="warning" outline class="content-alert">
                    This period is already frozen. You cannot modify Corrections, Tasks, TimeOff and Overtime.
                </v-alert>  
                <v-alert v-if="cutOffStatus==commonfn.getStatusCode('Closed')" :value="true" color="warning" icon="warning" outline class="content-alert">
                    This period is already closed. You cannot modify Corrections, Tasks, TimeOff and Overtime.
                </v-alert> 
                <v-alert v-if="timeReportStatus==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline class="content-alert">
                    This Timesheet has been approved already. You cannot modify Corrections, Tasks, TimeOff and Overtime.
                </v-alert> 
            </div>
            
            <v-layout row wrap class="mt-5"> 
                <v-flex xs12 >

                    <!--clockIn/ClockOut-->
                    <div class="mb-10">
                        <!-- already clocked-in, but not clocked-out -->
                        <!-- if already clocked-in and out, will be redirected to attendance daily page -->
                        <v-card v-if="clocked_in && !clocked_out" class="elevation-1" style="margin-bottom:10px;"> 
                            <v-toolbar flat height="35px">
                                <span class="font-weight-bold">Attendance</span>
                            </v-toolbar>
                            <v-data-table
                                :headers="isMobile? headers_attendance_mobile : headers_attendance"
                                :items="[my_data.attendance]"
                                hide-actions
                            >
                                <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                                <template v-slot:items="props">
                                    <tr>
                                        <td>Clock-In</td>
                                        <td :title="$moment(props.item.clockIn).format('MMM DD, YYYY h:mm a')" class="clickable">
                                            {{ props.item.clockIn | moment("h:mm a") }}
                                        </td>
                                        <td class="attendance-img">
                                            <v-img 
                                                :src="commonfn.getAttendanceThumbPicUrl(props.item.userId, $moment(props.item.transDate).format('YYYY-MM-DD'), 'ClockIn')" 
                                                height="50" 
                                                width="50" 
                                                class="clickable rounded-4"
                                                @click="showPicViewer(props.item, 'ClockIn')"
                                            ></v-img>                             
                                        </td>
                                        <td>{{ props.item.clockInDevice }}</td>
                                        <td>{{ props.item.clockInAddress }}</td>
                                        <td v-if="!isMobile">{{ props.item.clockInRemarks }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                        
                        <!-- has not clocked-in or out -->
                        <v-card v-if="!clocked_in || !clocked_out" class="elevation-1" > 
                            <v-toolbar flat :height="isMobile? 50 : 35">
                                <b>Attendance</b>
                                <v-spacer></v-spacer>
                                <v-chip 
                                    v-if="my_data.workShifts" 
                                    class="user-chip-container" 
                                    :style="{
                                        'background-color': my_data.workShifts.color,
                                        'color': getContrastColor(my_data.workShifts.color)
                                    }"
                                >
                                    {{workshift}}
                                </v-chip>
                            </v-toolbar>
                            <v-data-table
                                :headers="isMobile? headers_attendance_new_mobile : headers_attendance_new"
                                :items="[{}]"
                                hide-actions
                            >
                                <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                                <template v-slot:items="props">
                                    <tr>
                                        <td v-if="!isMobile">
                                            <span v-if="!clocked_in && !clocked_out">Clock-In</span>
                                            <span v-if="clocked_in && !clocked_out">Clock-Out</span>
                                        </td>
                                        <td>{{ serverDate| moment("h:mm:ss a") }}</td>
                                        <td></td>
                                        <td>{{ deviceDetailsSummary }}</td>
                                        <td v-if="!isMobile"></td>
                                    </tr>
                                </template>
                            </v-data-table> 
                            <v-divider></v-divider>
                            <v-card-actions class="mr-10">
                                <div class="text-xs-center" v-show="loading">
                                    <v-progress-linear indeterminate color="primary"></v-progress-linear>                
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn v-if="!clocked_in" color="primary" :loading="loading" :disabled="!withAssignedWorkShift || disableConditions" @click="showClockInOut('Clock-In')">
                                    <v-icon>timer</v-icon>&nbsp;Clock-In
                                </v-btn>
                                <v-btn v-if="clocked_in && !clocked_out" color="primary" :loading="loading" :disabled="!withAssignedWorkShift || disableConditions" @click="showClockInOut('Clock-Out')">
                                    <v-icon>timer</v-icon>&nbsp;Clock-Out
                                </v-btn>
                            </v-card-actions>
                        </v-card>

                        <!-- display total hours if already clocked-in -->
                        <v-card v-if="clocked_in" class="elevation-1"> 
                            <v-toolbar flat height="35px">
                                <span class="font-weight-bold ">Total Hours: {{totalHours}}</span>
                            </v-toolbar>
                        </v-card>
                    </div>

                    <!--TimeOffs-->
                    <!-- convert to component then share between MyAttendanceDaily and MyAttendanceToday -->
                    <v-card class="elevation-1 mb-10" v-if="haaTimeOff"> 
                        <v-toolbar flat height="35px">
                            <span class="font-weight-bold ">Time Off</span>
                            <v-spacer></v-spacer>
                            <v-btn icon title="File New Personal Time Off" @click="showPTO" :disabled="disableConditions">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile ? headers_timeoff_mobile: headers_timeoff"
                            :items="my_data.timeoff"
                            hide-actions
                            item-key="timeOffId"
                            :expand="expand"   
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="viewTimeOffDetails(props.item)" title="Click to view details" class="clickable">                                       
                                    <td>
                                        <span v-if="isMobile">{{props.item.transDate | moment("MMM DD")}}</span>
                                        <span v-else>{{props.item.transDate | moment("YYYY-MM-DD")}}</span>
                                    </td>
                                    <td>
                                        <div class="text-xs-left">{{parseFloat(props.item.hours).toFixed(2)}}</div>
                                    </td>
                                    <td>{{ props.item.leaveName }}</td>
                                    <td>
                                        <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                    </td>
                                    <td v-if="!isMobile">{{ props.item.remarks }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>

                    <!--Overtime--> 
                    <!-- convert to component then share between MyAttendanceDaily and MyAttendanceToday -->
                    <v-card class="elevation-1" v-if="hasOvertime"> 
                        <v-toolbar flat height="35px">
                            <span class="font-weight-bold ">Overtime</span>
                            <v-spacer></v-spacer>
                            <v-btn icon small title="File Overtime" @click="showOvertime" :disabled="disableConditions">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile?headers_overtime_mobile:headers_overtime"
                            :items="my_data.overtime"
                            :loading="loading"
                            hide-actions
                            item-key="overtimeId"
                            :expand="expand"    
                            >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="viewOvertime(props.item)" title="Click to view details" class="clickable">
                                    <td>{{ props.item.startTime | moment("hh:mm a") }} - {{ props.item.endTime | moment("hh:mm a") }}</td>
                                    <td>{{ props.item.hoursStr }}</td>
                                    <td v-if="!isMobile">{{ props.item.breakTime }}</td>
                                    <td>{{ props.item.chargeableHours }}</td>
                                    <td>
                                        <span v-if="props.item.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                                        <span v-if="props.item.offsetOrPay==2">Payroll (Paid Overtime)</span>
                                    </td>
                                    <td v-if="!isMobile">
                                        <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                    
                </v-flex>
            </v-layout>
        </v-flex>
        
        <!-- popup windows -->
        <v-dialog v-model="dialogClockInOut" width="450" persistent>   
            <clockInOut ref="clockInOutRef" @send="getMyAttendance(false)" :dialogClockInOut.sync="dialogClockInOut"></clockInOut>
        </v-dialog>
        <v-dialog v-model="dialogPTO" width="500" persistent>   
            <pto-component ref="ptoComponentRef" :enableDateRange="false" @send="ptoHandler" :dialogPTO.sync="dialogPTO"></pto-component>
        </v-dialog>
        <v-dialog v-model="dialogOvertime" width="600" persistent>   
            <overtime ref="overtimeRef" :showTransDatePicker="false" @send="overtimeHandler" :dialogOvertime.sync="dialogOvertime"></overtime>
        </v-dialog>
        <v-dialog v-model="dialogPicViewer" fullscreen hide-overlay transition="dialog-bottom-transition">   
            <pic-viewer ref="picViewerRef" :dialogPicViewer.sync="dialogPicViewer"></pic-viewer>
        </v-dialog>
    </v-layout>
</template>
<script> 

import myAttendanceApi from '@/api/myattendance'
import commonfn from '@/common/functions'           //for refactor, must separate functions based on feature/functionality
import { getUAData } from '@/helpers/user-agent'
import { hasAddRights } from '@/helpers/access-permissions'
import { getContrastColor } from '@/helpers/font-color'

export default {  
    name: 'MyAttendance',
    metaInfo: {
        title: 'My Attendance',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Clock-In / Clock-Out with user location, deviced used and picture, File Attendance Corrections, Overtime, Personal Time Off, Task Charges.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'pto-component': () => import('@/components/TimeOff/AddEditTimeOff'),
        'overtime': () => import('@/components/Overtime/AddEditOvertime'),
        'clockInOut': () => import('@/components/Attendance/ClockInOut'),
        'pic-viewer': () => import('@/components/Attendance/AttendancePicViewer'),
        'legal-docs-viewer': () => import("@/components/Common/LegalDocsViewer"),
    },      
    data () {
        return {
            commonfn,
            headers_attendance_new: [
                {text: 'Action',align: 'left',value: 'code',width: '15%', sortable:false},
                {text: 'Time',align: 'left',value: 'code',width: '15%', sortable:false},
                {text: 'Pic',align: 'left',value: 'hours',width: '15%', sortable:false},
                {text: 'Device',align: 'left',value: 'hours',width: '25%', sortable:false},
                {text: 'Remarks',align: 'left',value: 'hours',width: '25%', sortable:false}
            ],
            headers_attendance_new_mobile: [
                {text: 'Time',align: 'left',value: 'code',width: '30%', sortable:false},
                {text: 'Pic',align: 'left',value: 'hours',width: '30%', sortable:false},
                {text: 'Device',align: 'left',value: 'hours',width: '40%', sortable:false},
            ], 
            headers_attendance_mobile: [
                {text: 'Action',align: 'left',value: 'code',width: '25%', sortable:false},
                {text: 'Time',align: 'left',value: 'code',width: '25%', sortable:false},        
                {text: 'Pic',align: 'left',value: 'hours',width: '15%', sortable:false},
                {text: 'Device',align: 'left',value: 'hours',width: '30%', sortable:false},
            ],
            headers_attendance: [
                {text: 'Action',align: 'left',value: 'code',width: '15%', sortable:false},
                {text: 'Time',align: 'left',value: 'code',width: '15%', sortable:false},
                {text: 'Pic',align: 'left',value: 'hours',width: '20%', sortable:false},
                {text: 'Device',align: 'left',value: 'hours',width: '25%', sortable:false},
                {text: 'Remarks',align: 'left',value: 'hours',width: '25%', sortable:false},
            ],
            headers_timeoff: [
                {text: 'Date',align: 'left',value: 'code',width: '10%', sortable:false},
                {text: 'Hours',align: 'left',value: 'duration',width: '15%', sortable:false},
                {text: 'Type',align: 'left',value: 'type',width: '25%', sortable:false},
                {text: 'Status',align: 'left',value: 'status',width: '15%', sortable:false},
                {text: 'Remarks',align: 'left',value: 'remarks',width: '15%',sortable:false}
            ],
            headers_timeoff_mobile: [
                {text: 'Date',align: 'left',value: 'code',width: '30%', sortable:false},
                {text: 'Hours',align: 'left',value: 'duration',width: '10%', sortable:false},
                {text: 'Type',align: 'left',value: 'type',width: '50%', sortable:false},
                {text: 'Status',align: 'left',value: 'status',width: '15%', sortable:false}
            ],
            headers_overtime: [        
                {text: 'Duration',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Total Hours',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Break Time (mins)',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Chargeable Hours',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Charging Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '15%', sortable:false},               
            ],
            headers_overtime_mobile: [        
                {text: 'Duration',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Hours',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Chargeable',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},          
            ],
            loading: false,
            error: false,
            errorMessage: null,
            expand: false,
            my_data: null,            
            remarks: '',
            dialogClockInOut: false,
            dialogPicViewer: false,
            clockInOutDate: '',
            geoAddress: '',
            geoLocAllowedByUser: false,
            totalHours: '',
            increment_timer: null,
            compute_total_hrs_timer: null,
            serverDate: '',
            dialogPTO: false,
            dialogProjectTask: false,
            dialogOvertime: false,
            dialog: false,
            transDate: null,     
            userAgent: null,   
        }
    },
    methods: { 
        getContrastColor,
        viewTask(data) {
            const dt = this.$moment(data.transDate)
            this.$router.push(`/projects/charges/weekly/${dt.year()}/${dt.week()}`)
        },
        showPicViewer(data, action) {
            this.$refs.picViewerRef.viewAttenancePic(data, action)
            this.dialogPicViewer = true
        },
        showOvertime() {
            var data = {
                mode: 'Add',
                transDate: this.$moment(this.serverDate).format('YYYY-MM-DD'),
                overtimeId: 0
            }
            this.$refs.overtimeRef.setParams(data)
            this.dialogOvertime = true
        },
        async overtimeHandler() {
            await this.getMyAttendance(true)
            this.dialogOvertime = false
        },
        viewOvertime(data) {
            this.$router.push(`/myattendance/overtime/details/${data.overtimeId}`)
        },
        viewTimeOffDetails(data) {
            this.$router.push(`/myattendance/timeoff/details/${data.timeOffId}`)
        },
        showClockInOut(action){
            const data = {
                action: action,
                workShiftId: this.my_data.workShifts.workShiftId,
                workshiftColor: this.my_data.workShifts.color,
                workshift: this.workshift,
                clockInOutDate: this.clockInOutDate,
                device: this.deviceDetailsSummary,
                clockInOutPicRequired: this.my_data.workDay.clockInOutPicRequired
                
            }
            this.$refs.clockInOutRef.setParams(data)
            this.dialogClockInOut = true
        },
        async getMyAttendance(show_loading) {
            try {
                this.loading = show_loading
                const response = await myAttendanceApi.get()
                if (response.status==200) {
                    this.my_data = response.data
                    this.clockInOutDate = response.data.serverDate.local_date  
                    this.serverDate = response.data.serverDate.local_date 
                    
                    if (response.data.attendance) {
                        this.transDate = response.data.attendance.transDate
                    } else {
                        this.transDate = response.data.serverDate.local_date 
                    }
                }
                
                if (!this.clocked_out) {
                    this.compute_total_hrs_timer = setInterval(this.computeTotalHours, 1000)
                }
                
                if (this.clocked_in && this.clocked_out) {
                    var transDate = this.$moment(this.transDate).format("YYYY-MM-DD")
                    this.$router.push(`/myattendance/daily/${transDate}`)
                }
                
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        computeTotalHours() {
            var totalHours = '0'
            var totalMins = '0'
            var totalSecs = '0'

            if (this.clockInDate) {
                var duration = this.$moment.duration(this.$moment(this.serverDate).diff(this.$moment(this.clockInDate)))
                totalHours = duration.hours()
                totalMins = duration.minutes()
                totalSecs = duration.seconds()
            }
            this.totalHours = `${totalHours}:${totalMins}:${totalSecs}`         
        },
        showPTO() {
            var data = {
                withPTO: this.haaTimeOff,
                mode: 'Add',
                transDate: this.$moment(this.serverDate).format('YYYY-MM-DD'),
                workShift: this.workshift,
                duration: null,
                type: null,
                remarks: ''
            }

            this.$refs.ptoComponentRef.setParams(data)
            this.dialogPTO = true
        },
        async ptoHandler(){
            await this.getMyAttendance(true)
            this.dialogPTO = false
        },
        viewNext() {
            var nextDate = this.$moment(this.serverDate).add(1, 'days').format("YYYY-MM-DD")
            this.$router.push(`/myattendance/daily/${nextDate}`)
        },
        viewPrevious() {
            var prevDate = this.$moment(this.serverDate).add(-1, 'days').format("YYYY-MM-DD")
            this.$router.push(`/myattendance/daily/${prevDate}`)
        },
        incrementTime() {
            this.serverDate = this.$moment(this.serverDate).add(1, 'seconds')
            this.clockInOutDate = this.$moment(this.clockInOutDate).add(1, 'seconds')
        },
    },
    async created() {
        this.userAgent = await getUAData()

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMenu: false,
            headerTitle: '',
            headerPageTitle: this.$moment(new Date()).format('ddd, DD MMM YYYY')
        })

        await this.getMyAttendance(true) 
        
        //create client side timer
        this.increment_timer = setInterval(this.incrementTime, 1000)  //1second

        //refresh date from server every 5mins
        this.serverDateTimer = setInterval(this.getMyAttendance, 300000) //refresh every 1hr 
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        deviceDetailsSummary() {
            // Fallback for environments that don't support optional chaining
            return (this.userAgent && this.userAgent.deviceName) 
                ? this.userAgent.deviceName 
                : "Detecting device...";
        },
        hasOvertime() {
            return this.my_data && this.my_data.overtime.length
        },
        haaTimeOff() {
            return this.my_data && this.my_data.timeoff.length
        },
        hasCutoffData() {
            return this.my_data && this.my_data.cutoff
        },
        cutOffStatus() {
            var cutOffStatus = 0
            if (this.my_data && this.my_data.cutoff) {
                cutOffStatus = this.my_data.cutoff.status
            }
            return cutOffStatus
        },
        clockInDate() {
            var clockindate = ''
            if (this.my_data && this.my_data.attendance) {
                clockindate = this.my_data.attendance.clockIn
            }
            return clockindate
        },
        clocked_in() {
            if (this.my_data) return this.my_data.attendance
        },
        clocked_out() {
            return this.my_data && this.my_data.attendance && this.my_data.attendance.clockOut
        },
        workshift() {
            var workshift = ''
            if (this.my_data && this.my_data.workShifts) {
                var strict = this.my_data.workShifts.strict ? 'Strict' : 'Flexible'
                workshift = this.my_data.workShifts.name + ' (' + this.$moment(this.my_data.workShifts.clockStart).format("h:mm a") + ' - ' + this.$moment(this.my_data.workShifts.clockEnd).format("h:mm a") + ') ' + strict
            }
            return workshift
        },
        withAssignedWorkShift() {
            if (!this.loading) return this.my_data.workShifts
        },
        timeReportStatus() {
            return this.my_data && this.my_data.timeReport ? this.my_data.timeReport.status : 0
        },
        disableConditions() {
            return (
                    this.cutOffStatus == commonfn.getStatusCode('Frozen') || 
                    this.cutOffStatus == commonfn.getStatusCode('Closed') || 
                    this.timeReportStatus == commonfn.getStatusCode('Approved') ||
                    !this.hasCutoffData
                )
        },
        isHoliday() {
            if (!this.loading) {
                return this.my_data.holiday
            }
        },
        holidayDescription() {
            if (!this.loading && this.my_data.holiday) {
                return `${this.my_data.holiday.description} - ${this.my_data.holiday.holidayTypeName}`
            }
        },
    },
    destroyed() {
        clearInterval(this.increment_timer)
        clearInterval(this.serverDateTimer)
        clearInterval(this.compute_total_hrs_timer)
    }
}
</script>
<style scoped>
.apps-container {
    margin-left:-15px;
}
.content-alert {
    margin:5px 0px 0px 0px;
    border-radius: 4px;
}
.attendance-img {
    padding:3px 0px 3px 10px;
}
</style>